import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {HTH} from "../HTH";
import {HTHSymbol, ISymbolData} from "../symbols/HTHSymbol";
import {HTHAvalancheReelModel} from "./HTHAvalancheReelModel";
import {HTHGameConfig} from "../HTHGameConfig";
import {gsap} from "gsap";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {HTHEnhancerSymbol} from "../symbols/HTHEnhancerSymbol";
import {HTHSafeSymbol} from "../symbols/HTHSafeSymbol";
import {LayerSet} from "./LayerSet";
import {HTHXNudgeSymbol} from "../symbols/HTHXNudgeSymbol";
import {HTHEnhancerFrame} from "../view/HTHEnhancerFrame";
import {HTHSound} from "../sound/HTHSound";
import {EnhancerSpinArea} from "./enhancerSpin/EnhancerSpinArea";
import {HTHHelper} from "../utils/HTHHelper";
import {HTHNormalSymbol} from "../symbols/HTHNormalSymbol";


export class HTHReelArea extends PIXI.Container implements StageLayer {
    public readonly DROP_IN_REEL_DELAY: number = 0.05;
    public ebSpinArea: EnhancerSpinArea;
    public readonly SPECIAL_SYMBOL_LANDIND_DELAY: number = 0.5;
    public enhancerFrame: HTHEnhancerFrame;
    private readonly FAST_DROP_IN_REEL_DELAY: number = 0.05;
    private readonly DROP_OUT_REEL_DELAY: number = 0.02;
    private readonly FILL_UP_REEL_DELAY: number = 0.05;
    private readonly FAST_FILL_UP_REEL_DELAY: number = 0.02;
    private readonly COLLAPSE_REEL_DELAY: number = 0.05;
    private readonly DROP_IN_NEAR_WIN_DELAY: number = 1;
    private readonly FAST_DROP_IN_NEAR_WIN_DELAY: number = 0.4;
    private _layerSet: LayerSet;
    private _noWinSprite: PIXI.Sprite;
    private _reelSpinOutFire: PIXI.spine.Spine;
    private _ebBlankContainer: PIXI.Container;

    constructor() {
        super();
        this.init();
    }

    private _allReels: HTHAvalancheReelModel[];

    get allReels(): HTHAvalancheReelModel[] {
        return this._allReels;
    }

    private _needFillUpReels: boolean[];

    public get needFillUpReels(): boolean[] {
        return this._needFillUpReels;
    }

    get isFastSpin(): boolean {
        if (HTH.apiPlugin.settings.get(APISetting.FAST_SPIN, false)) {
            return true;
        }
        return false;
    }

    public reInitReels() {
        const reelsData: ISymbolData[][] = HTH.model.reelsData;
        for (let i: number = 0; i < reelsData.length; i++) {
            const reel = this._allReels[i];
            reel.reInitReels(reelsData[i]);
        }
    }

    public initForAS() {
        const reelsData: ISymbolData[][] = HTH.model.reelDataForAS;
        this.resetEnhancersForAS();
        for (let i: number = 0; i < reelsData.length; i++) {
            const reel = this._allReels[i];
            reel.initForAS(reelsData[i]);
        }
    }

    public dropIn(jurisdictionDelay: number): gsap.core.Timeline {
        HTHGameConfig.scatterCount = 0;
        HTHGameConfig.isAnticipationPlaying = false;
        const animations: gsap.core.Timeline = gsap.timeline(),
            hasAnticipation: boolean = this.isFastSpin,
            nearwinReels: boolean[] = HTH.model.nearWinReels,
            nearWinDelay: number = this.isFastSpin ? this.FAST_DROP_IN_NEAR_WIN_DELAY : this.DROP_IN_NEAR_WIN_DELAY,
            dropInDelay: number = this.isFastSpin ? this.FAST_DROP_IN_REEL_DELAY : this.DROP_IN_REEL_DELAY,
            padding: number = MathHelper.roundToDecimals(jurisdictionDelay / 5, 1);
        this._needFillUpReels = [true, true, true, true, true, true];
        let delay: number = 0;
        let specialLandingDelay: number = 0;
        this._allReels.forEach((reel: HTHAvalancheReelModel, i: number) => {
            // const containsSpecialSym: boolean = HTH.model.gameData.reels[i].filter((item) => (!(item.includes("M") || item.includes("L") || item.includes("EB")))).length > 0;
            delay += dropInDelay + (nearwinReels[i] ? nearWinDelay : 0); //+ specialLandingDelay;
            animations.add(reel.reelView.dropIn(delay + padding * i, nearwinReels[i + 1]), 0);
            // containsSpecialSym ? specialLandingDelay = this.SPECIAL_SYMBOL_LANDIND_DELAY : specialLandingDelay = 0;
        });
        return animations;
    }

    public dropOut(normalBet: boolean): gsap.core.Timeline {
        const animations: gsap.core.Timeline = gsap.timeline();
        this._allReels.forEach((reel: HTHAvalancheReelModel, i: number) => {
            animations.add(reel.reelView.dropOut(Math.abs(2.5 - i) * this.DROP_OUT_REEL_DELAY, normalBet), 0);
        });
        return animations;
    }

    public fillUp(): gsap.core.Timeline {
        const animations: gsap.core.Timeline = gsap.timeline(),
            isFastSpin: boolean = this.isFastSpin;
        let delay: number = 0;
        let nextFillUpdelay: number = 0;
        HTHGameConfig.isAnticipationPlaying = false;
        let alreadyFilled: boolean[] = [false, false, false, false, false, false];
        this._needFillUpReels = [true, true, true, true, true, true];
        let nearWinDelay: number = 0;
        HTHSound.resetSoundStuff();
        //loop
        alreadyFilled.forEach((item: boolean, index: number) => {
            if (!this.allReels[index].reelView.needFillUp) {
                alreadyFilled[index] = true;
            }
        })
        this._allReels.forEach((reel: HTHAvalancheReelModel, i: number) => {
            delay += (i * (isFastSpin ? this.FAST_FILL_UP_REEL_DELAY : this.FILL_UP_REEL_DELAY) + nearWinDelay);
            if (HTH.model.nearWinReels[0] && i == 0) {
                delay += nearWinDelay;
            }


            // const oneReelLabel: string = `reel_${i}_complete`;
            if (reel.reelView.needFillUp) {
                animations.add(reel.reelView.fillUp(delay, isFastSpin, HTH.model.nearWinReels[i]), 0);
                if (alreadyFilled.lastIndexOf(false) <= i || HTH.model.nearWinReels.lastIndexOf(true) <= i) {
                    animations.add(HTH.reelArea.allReels[5].reelView.stopScatterAnticipation());
                    animations.add(() => {
                        HTH.reelAnticipation.reset();
                    });
                }
                nextFillUpdelay += (isFastSpin ? this.FAST_FILL_UP_REEL_DELAY : this.FILL_UP_REEL_DELAY) + nearWinDelay;
            } else {
                const tl: gsap.core.Timeline = gsap.timeline();
                tl.add(HTH.reelArea.ebSpinArea.stopSpin(i, false, nextFillUpdelay));
                animations.add(tl, `reel_${i - 1}_complete`);
                animations.add(reel.reelView.revealEnhancerSymbol(), ">");
                animations.add(reel.reelView.revealSafeSymbols(), "<");

                this._needFillUpReels[i] = false;
            }
            animations.addLabel(`reel_${i}_complete`);
            if (HTH.model.nearWinReels[i]) {
                nearWinDelay = isFastSpin ? this.FAST_DROP_IN_NEAR_WIN_DELAY : this.DROP_IN_NEAR_WIN_DELAY;
            } else {
                nearWinDelay = 0;
            }
        });

        return animations;
    }

    public collapse(): gsap.core.Timeline[] {
        const animations: gsap.core.Timeline[] = [];
        let delay: number = 0;
        HTHSound.resetSoundStuff();
        this._allReels.forEach((reel: HTHAvalancheReelModel) => {
            reel.reelView.calculateCollapseData();
            if (reel.reelView.needCollapse) {
                animations.push(reel.reelView.collapse(delay));
                delay += this.COLLAPSE_REEL_DELAY;
            }
        });
        return animations;
    }

    public resetEnhancers(): gsap.core.Timeline {
        const rsTl: gsap.core.Timeline = gsap.timeline();
        let count: number = 0;
        HTH.reelArea.enhancerFrame.deleteMask();
        for (let reelID: number = 1; reelID < this._allReels.length - 1; reelID++) {
            const ebSym: HTHEnhancerSymbol = <HTHEnhancerSymbol>this.getSymbol([reelID, 3]);
            if (ebSym.symName === "EB" && ebSym.isEnhancerOpen) {
                count++;
                rsTl.add(ebSym.lockSymbol(), 0);
                rsTl.add(() => {
                    ebSym.emptyRevealContainer();
                    ebSym.isEnhancerOpen = false;
                    // ebSym.resetSpine(); todo: check why resetting spine causes visual defects
                }, 0);
                if (count === 1) {
                    rsTl.add(() => {
                        HTHSound.playTrack(HTHSound.ENHANCER_CELL_DOOR_LOCK_ON);
                    })
                }
            }

            if (HTH.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "GOD_MODE") {
                rsTl.add(ebSym.symbolAnimChange("inactive_one"));
            } else {
                rsTl.add(ebSym.symbolAnimChange("inactive_on_nobg"));
            }
        }
        // console.log("ebduration", rsTl.totalDuration());

        return rsTl;
    }

    public resetEnhancersForAS() {
        HTH.reelArea.enhancerFrame.deleteMask();
        for (let reelID: number = 1; reelID < this._allReels.length - 1; reelID++) {
            const ebSym: HTHEnhancerSymbol = <HTHEnhancerSymbol>this.getSymbol([reelID, 3]);
            if (ebSym.symName === "EB" && ebSym.isEnhancerOpen) {
                ebSym.lockSymbol().progress(1);
                ebSym.emptyRevealContainer();
                ebSym.isEnhancerOpen = false;
                // ebSym.resetSpine(); todo: check why resetting spine causes visual defects
            }

            if (HTH.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "GOD_MODE") {
                ebSym.symbolAnimChange("inactive_one")
            } else {
                ebSym.symbolAnimChange("inactive_on_nobg")
            }
        }
        // console.log("ebduration", rsTl.totalDuration());

    }

    public nudgeForRestoreOrInit(isRestore: boolean) {
        HTH.model.xNudgePositionPerReel.forEach(arr => {
            if (arr.length > 0) {
                const xNSym: HTHSymbol = this.getSymbol(arr);
                if (!this.allReels[xNSym.reelId].reelView.isStacked) {
                    const nudgeTl: gsap.core.Timeline = gsap.timeline();
                    nudgeTl.add(() => {
                        if (xNSym.symName === "SA" || xNSym.symName === "EB") {
                            const sym = ((<HTHSafeSymbol | HTHEnhancerSymbol>xNSym).revealedSymbol!)
                            sym.movetoParticularMaskedLayer(HTH.reelArea.allReels[sym.reelId].reelView.reelLayers.fullWildSymbols);
                        } else {
                            xNSym.movetoParticularMaskedLayer(HTH.reelArea.allReels[xNSym.reelId].reelView.reelLayers.fullWildSymbols);
                        }
                    })
                    this.runNudgeAnimForRestore(xNSym);
                    (<HTHXNudgeSymbol | HTHEnhancerSymbol | HTHSafeSymbol>xNSym).updatexNudgeMultiplierForRestore(isRestore);
                }
                for (let i: number = 0; i < 4; i++) {
                    const sym: HTHSymbol = this.getSymbol([arr[0], i]);
                    if (sym.symName !== "SA" && sym.symName !== "EB") {
                        if (sym.name === "XN" && i === arr[1]) {

                        } else {
                            sym.destroyForNudge();
                        }
                    }
                }
            }
        })
        HTH.model.xNudgePositionPerReel.forEach(arr => {
            if (arr.length > 0) {
                const xNSymbol: HTHSymbol = this.getSymbol(arr);
                this.allReels[xNSymbol.reelId].reelView.makeBlankSymbolsOnReel(false, xNSymbol.id);//make. blank symbol
            }
        });
    }


    public getSymbol(pos: number[]): HTHSymbol {
        return this._allReels[pos[0]].reelView.getSymbol(pos[1]);
    }

    public setNoWinSprite(dur: number = 0.15): gsap.core.Timeline {
        const noWinTl: gsap.core.Timeline = gsap.timeline();
        noWinTl.add(() => {
            this._noWinSprite.visible = true;
        }, 0);
        noWinTl.to(this._noWinSprite, {duration: dur, alpha: 0.7});
        return noWinTl;
    }

    public unSetNoWinSprite(duration: number = 0.15): gsap.core.Timeline {
        const normalTl: gsap.core.Timeline = gsap.timeline();
        normalTl.to(this._noWinSprite, {duration: duration, alpha: 0}, 0);
        normalTl.add(() => {
            this._noWinSprite.visible = false;
        }, ">");
        return normalTl;
    }

    public playReelFireEffect(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this._reelSpinOutFire.visible = true;
        }, 0);
        tl.add(HTHHelper.playSpineWithTimeline(this._reelSpinOutFire, 0, "loop"));
        tl.add(() => {
            HTHHelper.resetSpineItem(this._reelSpinOutFire);
        })
        return tl;
    }

    public makeBlurFilterNull(): void {
        this.allReels.forEach((reelModel: HTHAvalancheReelModel, index: number) => {
            [0, 1, 2, 3].forEach((rowID: number) => {
                const sym: HTHSymbol = reelModel.reelView.getSymbol(rowID);
                if ((sym.name.includes("M") && sym.symName !== "MAX") || (sym.name.includes("L") && sym.symName !== "BL")) {
                    (<HTHNormalSymbol>sym).makeBlurFilter(0, 0);
                }
            })
        });
    }

    private runNudgeAnimForRestore(xNSymbol: HTHSymbol, isRestore: boolean = true) {
        let isEnhancerOpen: boolean = true;

        const sym: HTHSymbol = this.getSymbol([xNSymbol.reelId, 3]);
        if (sym.symName === "EB") {
            if (!(<HTHEnhancerSymbol>sym).isEnhancerOpen) {
                isEnhancerOpen = false;
            }
        }
        if (xNSymbol.name === "EB") {
            (<HTHEnhancerSymbol>xNSymbol).playXNudgeAnim(xNSymbol.id, isEnhancerOpen, isRestore);
        } else if (xNSymbol.name === "SA") {
            (<HTHSafeSymbol>xNSymbol).playXNudgeAnimForRestore(xNSymbol.id, isEnhancerOpen, isRestore);
        } else {
            (<HTHXNudgeSymbol>xNSymbol).playXNudgeAnim(xNSymbol.id, isEnhancerOpen, isRestore);
        }

    }

    private init(): void {
        this.name = "ReelAreaView";
        this._allReels = [];

        const reelsData: ISymbolData[][] = HTH.model.reelsData;
        const reelsAfterCollapseData: ISymbolData[][] = HTH.model.reelsFillUpData;
        let tempReel: ISymbolData[];

        for (let i: number = 0; i < reelsData.length; i++) {
            tempReel = [];
            const reelModel: HTHAvalancheReelModel = new HTHAvalancheReelModel(i);
            this._allReels.push(reelModel);
            HTH.model.isRestore ? reelModel.init(reelsAfterCollapseData[i]) : reelModel.init(reelsData[i]);
        }

        this._layerSet = new LayerSet();
        for (let j: number = 0; j < this._allReels.length; j++) {
            this._layerSet.addLayerSet(this._allReels[j].reelView.reelLayers);

        }
        this._reelSpinOutFire = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("SpinOutReelFire"));
        this._reelSpinOutFire.position.set(365, 150);
        this._reelSpinOutFire.name = "spinoutfire";
        this._reelSpinOutFire.alpha = 0.9;
        this._reelSpinOutFire.visible = false;

        this._ebBlankContainer = this.createBlankEB();


        //(L1-L5,M1-M5)<XW<W<XS<RW<SC<EB<SA<XN

        this.ebSpinArea = new EnhancerSpinArea();

        this.addChild(this._layerSet.normalLayer);
        this.addChild(this._layerSet.normalSpecial);
        this.addChild(this._layerSet.xWLayer);
        this.addChild(this._layerSet.wildLayer);
        this.addChild(this._layerSet.xSplitLayer);
        this.addChild(this._layerSet.removalSymLayer);
        this.addChild(this._layerSet.scatterLayer);
        this.addChild(this._reelSpinOutFire);
        this.addChild(this._ebBlankContainer);
        this.addChild(this.ebSpinArea);
        this.addChild(this._layerSet.enhancerBlockLayer);
        this.addChild(this._layerSet.safeLayer);
        this.addChild(this.enhancerFrame = new HTHEnhancerFrame());
        this.addChild(this._layerSet.enhancerBlockOpenedLayer);
        this.addChild(this._layerSet.fullWildSymbols);
        this.addChild(this._layerSet.maskedEffectsLayer);
        // this.addChild(HTH.symbolOverlay);
        this.addNoWinSprite();
        HTH.additionalLayers.addChild(this._layerSet.winLayer);

        const mainReelsMask: PIXI.Graphics = new PIXI.Graphics();
        mainReelsMask.name = "reelAreaMask";
        mainReelsMask.beginFill(0xFFFF0B, 0.5);
        mainReelsMask.drawRect(-HTHGameConfig.symbolWidth - 130, -HTHGameConfig.symbolHeight / 2 - 1, this.getReelAreaWidth() * 1.5, this.getReelAreaHeight());

        this.addChild(mainReelsMask);
        this.mask = mainReelsMask;
        this.position = HTHGameConfig.reelAreaPos;
    }

    private getReelAreaWidth(): number {
        return (HTHGameConfig.symbolWidth * HTHGameConfig.reelsNum);
    }

    private getReelAreaHeight(): number {
        return HTHGameConfig.symbolHeight * 4;
    }

    private addNoWinSprite(): void {
        this._noWinSprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._noWinSprite.name = "nowinOverlay";
        this._noWinSprite.width = HTHGameConfig.symbolWidth * 6;
        this._noWinSprite.height = HTHGameConfig.symbolHeight * 4;
        this._noWinSprite.anchor.set(0.5, 0.5);
        this._noWinSprite.position.set(301, 225);
        this._noWinSprite.alpha = 0;
        this._noWinSprite.blendMode = PIXI.BLEND_MODES.MULTIPLY;
        this._noWinSprite.tint = PIXI.utils.string2hex("#414655");
        this._noWinSprite.visible = false;
        this.addChild(this._noWinSprite);
    }

    private createBlankEB(): PIXI.Container {
        const cont: PIXI.Container = new PIXI.Container();
        for (let i = 0; i < 4; i++) {
            const sprite: PIXI.Sprite = new PIXI.Sprite(HTH.assetLoader.getTextures("EB/EB_unlocked")[0]);
            sprite.name = `EB_unlocked ${i + 1}`;
            sprite.anchor.set(0.5, 0.5);
            cont.addChild(sprite);
            sprite.position.set(HTHGameConfig.symbolWidth * (i + 1), 2 + HTHGameConfig.symbolHeight * 3);
            cont.addChild(sprite);
        }
        cont.name = "Blank EB Container";
        return cont;
    }
}